var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:_vm.type},[_c('lessonIframe',{ref:"lessonIframe",attrs:{"id":_vm.id,"type":_vm.type},on:{"back":_vm.back,"runStep":_vm.runStep}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }